import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { isLowDataCount } from '../../../../client/components/analytics/shared/analytics-request.util';
import { UtilsService } from '../../../services/utils.service';
import { formatAnalyticsInt } from '../chart-theme';
import { LowDataBadgeComponent } from '../low-data-badge/low-data-badge.component';

// The one shared "Based on N mentions" caption for every chart and KPI card across all 7
// Analytics screens (docs/features/analitika - "Врз основа на N спомнувања"). A mention COUNT is
// always exact and always shown - never "insufficient" on its own, never replaced with "—".
// Analytics accuracy review follow-up (2026-11-01): there is no longer any floor below which this
// caption switches to an "insufficient data" message - a value is either real (count >= 1) or
// genuinely absent (count === 0, which callers render as "Нема вести"/"Ново" elsewhere, never as a
// caption on a chart/KPI that has nothing to caption).
// This component DOES still look at its own `count` to show the small "low data" badge
// (CLIPPING-threshold, 2026-10-25) whenever count is under LOW_DATA_THRESHOLD - a lighter, purely
// visual signal that applies even when the caption/value above it is a perfectly real number
// computed from only 1-4 mentions.
// Singular/plural picked in TS (two i18n keys per state) since ngx-translate has no ICU plural
// support installed in this project - same idiom as the Net Sentiment sub-label (Task 1).
@Component({
	selector: 'app-sample-size-note',
	standalone: true,
	imports: [TranslateModule, LowDataBadgeComponent],
	templateUrl: './sample-size-note.component.html',
})
export class SampleSizeNoteComponent {
	@Input({ required: true }) count!: number;

	constructor(private readonly utils: UtilsService) {}

	get translateKey(): string {
		return this.count === 1 ? 'ANALYTICS_SAMPLE.BASED_ON_ONE' : 'ANALYTICS_SAMPLE.BASED_ON_MANY';
	}

	get lowData(): boolean {
		return isLowDataCount(this.count);
	}

	// Задача 7: locale-formatted thousands grouping (mk/al dot, en comma) for the {{count}}
	// placeholder above - ngx-translate only does plain string substitution, so the number must
	// already be locale-correct before it gets here.
	get translateParams(): { count: string } {
		return { count: formatAnalyticsInt(this.count, this.utils.currentLanguage) };
	}
}
